import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultParentAccountsSlice = getCachedTableDataSlice<
    Record<string, string>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultParentAccounts');

export const accountSearchResultParentAccountsActions = accountSearchResultParentAccountsSlice.actions;

const accountSearchResultParentAccountsCacheSelector: CachedTableCacheSelector<Record<string, string>>
    = state => state.accountSearchResult.parentAccounts.cache;
export const accountSearchResultParentAccountsDataSelector: CachedTableDataSelector<Record<string, string>>
    = state => state.accountSearchResult.parentAccounts;
export const accountSearchResultParentAccountsResultSelector = getCachedTableResultSelector(
    accountSearchResultParentAccountsCacheSelector,
    accountSearchResultStateSelector,
);
